<template>
	<a v-bind:href="getLinkValue" class="btn_app btn prave_tlacitko prave_tlacitko_fix" style="margin-top: 25px;">
		{{textLink}}
	</a>
</template>

<script>
export default {
  name: "EshopLink",
  props : ['textLink', 'linkName'],
  computed: {
    getLinkValue () {
      if (this.$store.state.linksForEshop) {
        return this.$store.state.linksForEshop.find(e => e.eshopLinkId === this.linkName).linkValue
      } else {
        return  ''
      }
    }
  },
  beforeMount() {
    this.$store.commit('SET_ESHOP_LINK', {eshopLinkId: this.linkName, linkValue: 'https://eshop.t-mobile.cz/category/tariff-mobile-postpaid/list/product_listing?bp=acquisition&productOfferingTerm=noagreement&selectedToggle=TARIFF'})
  }
}
</script>

<style scoped>
.prave_tlacitko_fix {
	width: fit-content !important;
	margin: 0 auto;
	padding: 6px 60px;
}

.prave_tlacitko {
	width: 100%;
	grid-column: 1/6;
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 21px;
	line-height: 24px;
	text-align: center;
	letter-spacing: -0.3px;
	height: 45px;
	background-color: #e20074;
	color: #FFFFFF;
}


@media only screen and (max-width: 770px) {
	.prave_tlacitko {
		width: calc(100% - 32px) !important;
		margin-left: 16px;
		margin-right: 16px;
		grid-column: 1/3;
		margin-top: 12px;
	}
}


@supports (-webkit-touch-callout: none) {
	/* CSS specific to iOS devices */
	.prave_tlacitko {
		letter-spacing: -0.05rem !important;
	}
}

</style>
